import { React, useState, useEffect, Controller, Alert, useForm, DatePicker, Card, Toast, Breadcrumb, CustomTable, CustomModal, _formatDate, Icon, showDeleteOrRestoreMessage } from "../utils/commonImports";
import { Button } from "reactstrap";
import axios from "axios";
import dayjs from "dayjs";
import { apiUrl } from "../auth/Api";
import { _api } from '../auth/Api';
import RichTextEditor from "../components/RichTextEditor";
import { _exportToExcel } from "../helper/ExportToExcel";
import Select from "react-select";
import { customStyleMd } from "../utils/common";

const Promotions = () => {
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [viewModal, setViewModal] = useState({ isOpen: false, data: null });
  const { register, handleSubmit, reset, control, setValue, formState: { errors }, } = useForm();
  const [filterBtnShow, setFilterBtnShow] = useState(true)
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showExp, setShowExp] = useState({ isShow: false, msg: "" });
  const [filters, setFilters] = useState({
    id: 0,
    promotionCode: "",
    title: "",
    startDate: null,
    endDate: null,
    dateFilter: null,
  });

  useEffect(() => {
    _getPromotions();
  }, [])

  const _getPromotions = async (filterValues = {}, pageNo = page, numberOfRecords = pageSize) => {
    const payload = {
      id: 0,
      promotionCode: filterValues.promotionCode || "",
      title: filterValues.title || "",
      startDate: filterValues.startDate ? dayjs(filterValues.startDate).format("YYYY-MM-DD") : null,
      endDate: filterValues.endDate ? dayjs(filterValues.endDate).format("YYYY-MM-DD") : null,
      dateFilter: filterValues.dateFilter?.value || null,
      isActive: true,
      page: {
        pageNo,
        numberOfRecords,
      }
    };

    try {
      setLoading(true);
      await _api("POST", "Promotion/GetPromotions", payload, (res) => {
        if (res.isSuccess) {
          setPromotions(res.data);
          setTotalRecords(res.totalRecords || 0);
        } else {
          setPromotions([]);
          // Toast.fire({ icon: "error", title: res.message });
        }
        setLoading(false);
      });
    } catch (error) {
      console.error(error);
      setPromotions([]);
      Toast.fire({ icon: "error", title: "Failed to fetch promotions" });
    } finally {
      setLoading(false)
    }
  };

  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
    _getPromotions(filters, pagination.current, pagination.pageSize);
  };

  const handleReset = () => {
    setFilters({
      promotionCode: "",
      title: "",
      startDate: null,
      endDate: null,
      dateFilter: null,
    });
    setShowExp({ isShow: false, msg: "" })
    _getPromotions();
  };

  const handleApply = () => {
    const { promotionCode, title, startDate, endDate, dateFilter } = filters;
    if (!promotionCode && !title && !startDate && !endDate && !dateFilter) {
      setShowExp({ isShow: true, msg: "NOTE: Please fill at least one filter" })
      return;
    }
    if (dateFilter && !startDate && !endDate) {
      setShowExp({ isShow: true, msg: "NOTE: Please select (to) & (from) Date too." })
      return;
    }
    setPage(1);
    _getPromotions(filters, 1, pageSize);
  };

  const columns = [
    { title: "Code", dataIndex: "promotionCode" },
    { title: "Title", dataIndex: "title" },
    // {
    //   title: "Content",
    //   dataIndex: "content",
    //   width: 250,
    //   ellipsis: { showTitle: true },
    // },
    { title: "Redirection", dataIndex: "redirectLink", ellipsis: true },
    { title: "Start Date", dataIndex: "startDate", render: (startDate) => _formatDate(startDate) },
    { title: "End Date", dataIndex: "endDate", render: (endDate) => _formatDate(endDate) },
    { title: "Created On", dataIndex: "createDate", render: (createDate) => _formatDate(createDate) },
    {
      title: "Status", dataIndex: "isActive",
      render: (isActive) => (
        <span className={`badge ${isActive ? 'bg-success' : 'bg-danger'}`}>
          {isActive ? 'Active' : 'Inactive'}
        </span>
      )
    },
  ];

  const launchDetailModal = (type, record) => {
    setViewModal({ isOpen: type, data: record });
  };

  const launchModal = (data = {}, type) => {
    reset();
    if (data) {
      Object.keys(data).forEach((key) => {
        setValue(key, key.includes("Date") ? dayjs(data[key]) : data[key]);
      });
      setEditData(data);
    } else {
      setEditData(null);
    }
    setShowModal(type);
  };

  const _saveUpdatePromotions = async (data) => {
    setLoading(true);
    const formData = new FormData();
    const isUpdate = Boolean(data.promotionId && data.promotionId !== 0);
    formData.append("promotionId", isUpdate ? data.promotionId : 0);
    formData.append("promotionCode", data.promotionCode || "");
    formData.append("title", data.title || "");
    formData.append("content", data.content || "");
    formData.append("status", "Active");
    formData.append("redirectLink", data.redirectLink || "");

    if (data.startDate) formData.append("startDate", data.startDate.format("YYYY-MM-DD"));
    if (data.endDate) formData.append("endDate", data.endDate.format("YYYY-MM-DD"));

    if (data.file?.[0]) {
      formData.append("file", data.file[0]);
      formData.append("imageUrl", "");
    } else if (isUpdate && data.imageUrl) {
      formData.append("imageUrl", data.imageUrl);
    }

    const storedToken = localStorage.getItem("x_t");
    const token = storedToken ? JSON.parse(storedToken).t : null;
    const url = isUpdate
      ? `${apiUrl}Promotion/UpdatePromotion`
      : `${apiUrl}Promotion/AddPromotion`
    try {
      const res = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.data?.isSuccess) {
        Toast.fire({ icon: "success", title: res?.data?.message });
        setShowModal(false);
        reset();
        _getPromotions();
      } else {
        Toast.fire({ icon: "error", title: res?.data?.message || "Submission failed" });
      }
    } catch (err) {
      Toast.fire({ icon: "error", title: "API Error" });
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const _deletePromotion = async (d) => {
    const isConfirmed = await showDeleteOrRestoreMessage(d?.isActive ? "Delete" : "Restore");
    if (isConfirmed) {
      try {
        await _api('POST', `Promotion/DeletePromotion`, d?.promotionId, function (res) {
          if (res.isSuccess) {
            _getPromotions();
            Toast.fire({ icon: 'success', title: res.message })
          } else {
            Toast.fire({ icon: 'error', title: res.message })
          }
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const xlsColumns = [
    { title: "Promotion Id", dataIndex: "promotionId" },
    { title: "Promotion Code", dataIndex: "promotionCode" },
    { title: "Title", dataIndex: "title" },
    { title: "Image Url", dataIndex: "imageUrl" },
    { title: "Content", dataIndex: "content" },
    { title: "Redirect Link", dataIndex: "redirectLink" },
    { title: "Start Date", dataIndex: "startDate" },
    { title: "End Time", dataIndex: "endDate" },
    { title: "Created On", dataIndex: "createDate" },
    { title: "Status", dataIndex: "status" },
  ]
  const handleExport = async () => {
    setBtnLoading(true);

    const payload = {
      id: 0,
      promotionCode: "",
      title: "",
      startDate: null,
      endDate: null,
      createDate: null,
      isActive:true,
      page: {
        pageNo: 0,
        numberOfRecords: 0,
      }
    };

    try {
      await _api("POST", "Promotion/GetPromotions", payload, (res) => {
        if (res.isSuccess) {
          const krDateSahe = res.data.map((x) => ({
            ...x,
            startDate: _formatDate(x.startDate),
            endDate: _formatDate(x.endDate),
            createDate: _formatDate(x.createDate),
          }));
          setTimeout(() => {
            _exportToExcel({
              data: krDateSahe,
              columns: xlsColumns,
              fileName: "Promotions",
            });
            setBtnLoading(false);
          }, 1500);
        } else {
          setBtnLoading(false);
        }
      });
    } catch (error) {
      console.error(error);
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Breadcrumb title="Promotions" />
      {filterBtnShow && (
        <Card className=" mb-3">
          <div className="p-2 bg-white mb-3">
            <div className="row g-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Promotion Code"
                  value={filters.promotionCode}
                  onChange={(e) => setFilters({ ...filters, promotionCode: e.target.value })}
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={filters.title}
                  onChange={(e) => setFilters({ ...filters, title: e.target.value })}
                />
              </div>

              <div className="col-md-3">
                <Select
                  options={[
                    { value: 1, label: "Start Date" },
                    { value: 2, label: "End Date" },
                    { value: 3, label: "Created Date" },
                  ]}
                  value={filters.dateFilter}
                  onChange={(val) => setFilters({ ...filters, dateFilter: val || null })}
                  placeholder="Select Date Type"
                  isClearable
                  styles={customStyleMd}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.startDate ? dayjs(filters.startDate) : null}
                  onChange={(date) => setFilters({ ...filters, startDate: date })}
                  style={{ width: "100%" }}
                  disabledDate={(current) => {
                    if (filters.endDate && current < dayjs(filters.endDate)) return true;
                    return false;
                  }}
                  placeholder={filters.dateFilter?.value === null || undefined ? "Select Date Type" : "Date (From)"}
                  disabled={!filters.endDate && filters.dateFilter === null || undefined}
                />
              </div>

              <div className="col-md-3">
                <DatePicker
                  format="YYYY-MM-DD"
                  value={filters.endDate ? dayjs(filters.endDate) : null}
                  onChange={(date) => setFilters({ ...filters, endDate: date })}
                  style={{ width: "100%" }}
                  //disabledDate={(current) => {
                  //if (current && current > dayjs().endOf("day")) return true;
                  //if (filters.startDate && current > dayjs(filters.startDate)) return true;
                  //return false;
                  // }}
                  placeholder={filters.dateFilter?.value === null || undefined ? "Select Date Type" : "Date (To)"}
                  disabled={filters.dateFilter === null || undefined}
                />
              </div>



            </div>

            <div className="d-flex align-items-center justify-content-between gap-2 mt-3">
              <div className="flex-grow-1">
                {showExp.isShow && (
                  <Alert showIcon message={showExp.msg} type="warning" />
                )}
              </div>
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => setFilterBtnShow(false)}
                >
                  Hide Filter
                </button>
                <button className="btn btn-sm btn-outline-secondary" onClick={handleReset}>
                  Reset Filters
                </button>
                <button className="btn btn-sm btn-primary" onClick={handleApply}>
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        </Card>
      )}
      <Card>
        <div className="d-flex justify-content-end gap-2" style={{ marginBottom: "10px" }}>
          {!filterBtnShow && (
            <button
              onClick={() => setFilterBtnShow(true)}
              className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
              style={{ lineHeight: '1.2' }}
            >
              Filter Promotions
              <Icon icon="mdi:filter-cog-outline" className="text-md" />
            </button>
          )}
          <button
            onClick={() => launchModal({}, true)}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
          >
            Add Promotion <Icon icon="mdi:plus-circle-outline" className="text-md" />
          </button>
          <button
            onClick={handleExport}
            className="btn btn-outline-primary-600 radius-3 d-flex align-items-center gap-2 px-14 py-6 text-sm mb-2"
            style={{ lineHeight: '1.2' }}
            disabled={btnLoading}
          >
            {btnLoading && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {btnLoading ? "Exporting..." : "Export to Excel"}
            <Icon icon="mdi:microsoft-excel" className="text-md" />
          </button>
        </div>
        <CustomTable
          columns={columns}
          dataSource={promotions}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            currentLength: promotions.length
          }}
          onChange={handleTableChange}
          options={{
            withActions: true,
            showEdit: true,
            loading: loading,
            showDelete: true,
            showView: true,
            rowKey: "id",
            bordered: true,
            size: "small",
            emptyText: "No Promotions found",
            pageKey: 11
          }}
          onView={(d) => launchDetailModal(true, d)}
          onEdit={(rowData) => launchModal(rowData, true)}
          onDelete={(d) => _deletePromotion(d)}
        />
        <CustomModal
          title={editData && Object.keys(editData).length > 0 ? "Update Promotion" : "Add Promotion"}
          show={showModal}
          onHide={() => setShowModal(false)}
          size="xl"
        >
          <form onSubmit={handleSubmit(_saveUpdatePromotions)} className="row">
            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md">
                <label className="small">Promotion Code</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter code"
                  {...register("promotionCode", { required: "Code is required" })}
                />
                {errors.promotionCode && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.promotionCode.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md">
                <label className="small">Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  {...register("title", { required: "Title is required" })}
                />
                {errors.title && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.title.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md mt-2">
                <label className="small">Upload Image (Aspect Ratio 2:1)</label>
                <input
                  type="file"
                  accept="image/jpeg, image/png"
                  className="form-control"
                  {...register("file", {
                    required: !editData || Object.keys(editData).length === 0 ? "Image is required" : false,
                    validate: {
                      fileType: (fileList) => {
                        if (!fileList || !fileList[0]) return true; // Skip validation if no file selected
                        return ["image/jpeg", "image/png"].includes(fileList[0].type)
                          ? true
                          : "Only JPEG or PNG images are allowed";
                      },
                    },
                  })}
                />

                {errors.file && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">{errors.file.message}</span>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md mt-2">
                <label className="small">Redirect Link</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter redirect link"
                  {...register("redirectLink", { required: "Redirect Link is required" })}
                />
                {errors.redirectLink && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.redirectLink.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md">
                <label className="small">Start Date</label>
                <Controller
                  control={control}
                  name="startDate"
                  rules={{ required: "Start Date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      format="YYYY-MM-DD"
                      className="form-control"
                      style={{ width: "100%" }}
                      inputReadOnly
                    />
                  )}
                />
                {errors.startDate && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.startDate.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group mb-3 input-group-md">
                <label className="small">End Date</label>
                <Controller
                  control={control}
                  name="endDate"
                  rules={{ required: "End Date is required" }}
                  render={({ field }) => (
                    <DatePicker
                      {...field}
                      format="YYYY-MM-DD"
                      className="form-control"
                      style={{ width: "100%" }}
                      inputReadOnly
                    />
                  )}
                />
                {errors.endDate && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.endDate.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-12">
              <div className="form-group mb-3 input-group-md">
                <label className="small">Content</label>
                <Controller
                  name="content"
                  control={control}
                  rules={{ required: "Content is required" }}
                  render={({ field }) => (
                    <RichTextEditor
                      value={field.value}
                      onChange={(newContent) => field.onChange(newContent)}
                      placeholder="Enter content"
                    />
                  )}
                />

                {errors.content && (
                  <span className="badge text-xs fw-normal text-danger-600 bg-danger-100 py-4 radius-4 text-white">
                    {errors.content.message}
                  </span>
                )}
              </div>
            </div>


            <div className="col-12 mt-2">
              <Button
                className="btn btn-changan btn-sm float-end"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  editData && Object.keys(editData).length > 0 ? "Update" : "Save"
                )}
              </Button>
            </div>
          </form>
        </CustomModal>
      </Card>
      <CustomModal
        title="View Promotion"
        show={viewModal.isOpen}
        size="lg"
        onHide={() => setViewModal(false, {})}
      >
        {viewModal.data && (
          <div className="row g-3">
            <div className="col-md-2">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Code:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.promotionCode}</div>
              </div>
            </div>

            <div className="col-md-5">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Title:</small>
                <div className="fw-semibold text-sm">{viewModal.data?.title}</div>
              </div>
            </div>

            <div className="col-md-5">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Redirect Link:</small>
                <div className="fw-semibold text-sm">
                  <a href={`https://${viewModal.data?.redirectLink}`} target="_blank" rel="noopener noreferrer">
                    {viewModal.data.redirectLink}
                  </a>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Start Date:</small>
                <div className="fw-semibold text-sm">{viewModal.data.startDate?.slice(0, 10)}</div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">End Date:</small>
                <div className="fw-semibold text-sm">{viewModal.data.endDate?.slice(0, 10)}</div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Status:</small>
                <div>
                  <span className={`badge ${viewModal.data?.status === "Active" ? "bg-success" : "bg-danger"}`}>
                    {viewModal.data?.status}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="border rounded py-2 px-3 bg-light shadow-sm h-90">
                <small className="text-muted text-sm">Content:</small>
                <div className="fw-semibold text-sm" dangerouslySetInnerHTML={{ __html: viewModal.data?.content }} />
              </div>
            </div>

            <div className="col-12">
              <div className="border rounded p-3 bg-light shadow-sm text-center">
                {/* <small className="text-muted d-block mb-2">Promotion Image:</small> */}
                <img
                  src={viewModal.data?.imageUrl}
                  alt="Promotion Image"
                  style={{ maxWidth: "100%", height: "auto", maxHeight: "300px", objectFit: "contain" }}
                />
              </div>
            </div>
          </div>
        )}
      </CustomModal>
    </>
  );
};

export default Promotions;